export default "__VITE_ASSET__Cvcs3b9C__"